export const regionalOverview = {
  defaultYear: "Année par défaut",
  selectYear: "Sélectionnez l'année à comparer",
  selectedYear: "Année sélectionnée",
  note: "*Remarque : Les données présentées dans ces graphiques représentent des informations qui ont été approuvées par le gouvernement.",
};
